(function( $ ) {
    function initMap( $el ) {
        var $markers = $el.find('.marker');
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            disableDefaultUI: true,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            styles : [
                {
                  featureType: "poi",
                  stylers: [
                   { visibility: "off" }
                  ]   
                }
            ]         
        };
        var map = new google.maps.Map( $el[0], mapArgs );
    
        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map, $el );
        });

        // Center map based on markers.
        centerMap( map );
    
        return map;
    }

    function initMarker( $marker, map, $el ) {
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };
        var target = $marker.data('target');
        var active = $marker.data('active');

        var iconDefault = new google.maps.MarkerImage($marker.data('icon-default'));
        var iconActive = new google.maps.MarkerImage($marker.data('icon-active'));
        var iconInit = iconDefault;

        var opacityDefault = 0.7;
        var opacityActive = 1;
        var opacityInit = opacityDefault;

        if (active == true) {
            opacityInit = opacityActive;
        }

        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map : map,
            icon : iconDefault,
            opacity : opacityInit
        });
    
        map.markers.push( marker );
    
        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ) {
    
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });
    
            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                let $informations = $('.informations-address');
                $informations.removeClass('active');
                $(target).addClass('active');

                for (var i = 0; i < map.markers.length; i++) {
                    map.markers[i].setOpacity(opacityDefault);
                }
                this.setOpacity(opacityActive);
            });
        }
    }

    function centerMap( map ) {
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });
    
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );
        } else{
            map.fitBounds( bounds );
        }
    }
    
    // Render maps on page load.
    $(document).ready(function(){
        $('.acf-center-map').each(function(){
            var map = initMap( $(this) );
        });
    });
})(jQuery);